import { memo } from 'react'
import { Pressable, StyleSheet } from 'react-native'
import { Chip, Icon, Tooltip } from 'react-native-paper'
import { useSemanticColors } from '@/constants/SemanticColors'

interface EntryTypeChipProps {
    type: string
    onPress?: () => void
    iconOnly?: boolean
}

function getTypeIcon(type: string) {
    switch (type) {
        case 'manual':
            return 'invoice-text-edit'
        case 'timer':
            return 'clock-outline'
        case 'geofence':
            return 'map-marker-radius'
        case 'travel':
            return 'truck-fast-outline'
        case 'break':
            return 'coffee-outline'
        case 'between_jobs':
            return 'car-outline'
        case 'none':
            return 'power-sleep'
        default:
            return 'circle'
    }
}

export const EntryTypeChip = memo(function EntryTypeChip({
    type,
    onPress,
    iconOnly,
}: EntryTypeChipProps) {
    const semanticColors = useSemanticColors()

    const getTypeColor = (entryType: string) => {
        switch (entryType) {
            case 'manual':
                return semanticColors.warning
            case 'timer':
                return semanticColors.info
            case 'geofence':
                return semanticColors.success
            case 'travel':
                return semanticColors.neutral
            case 'break':
                return semanticColors.warning
            case 'between_jobs':
                return semanticColors.neutral
            case 'none':
                return semanticColors.mutedText
            default:
                return semanticColors.neutral
        }
    }

    const color = getTypeColor(type)

    if (iconOnly) {
        const icon = <Icon source={getTypeIcon(type)} size={18} color={color} />
        if (onPress) {
            return (
                <Pressable onPress={onPress} hitSlop={8}>
                    {icon}
                </Pressable>
            )
        }
        return <Tooltip title={type}>{icon}</Tooltip>
    }

    return (
        <Chip
            mode="outlined"
            icon={getTypeIcon(type)}
            style={[styles.chip, { borderColor: color }]}
            textStyle={{ color, fontSize: 11 }}
            compact
            onPress={onPress}
        >
            {type}
        </Chip>
    )
})

const styles = StyleSheet.create({
    chip: {
        textTransform: 'capitalize',
        alignItems: 'center',
        display: 'flex',
    },
})
